import * as angular from 'angular';

import { ComponentDefinition, IMenuItem } from '../../models';

class PanelSettingsController implements angular.IComponentController {
    isLoading: boolean;
    items: IMenuItem[];
    loadingMessage: string;
    tooltip: string;

    static $inject = [];

    stopPropagation(event: angular.IAngularEvent): void {
        event.stopPropagation();
    }
}

export const wtPanelSettings: ComponentDefinition = {
    componentId: 'wtPanelSettings',
    controller: PanelSettingsController,
    template: require('./panelSettings.component.html'),
    controllerAs: 'vm',
    bindings: {
        titleText: '@',
        items: '='
    }
};
